import React, { useEffect, useState, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUndo, faEye, faTrash, faEdit, faPlus } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

const ListArticles = () => {
  const [articles, setArticles] = useState([]);
  const [showTrash, setShowTrash] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const fetchArticles = async (includeDeleted = false) => {
    try {
      const token = localStorage.getItem('token');
      const url = includeDeleted ? '/article?withDeleted=true' : '/article';
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) throw new Error('Erreur lors du chargement des articles');

      const data = await response.json();
      setArticles(data);
    } catch (err) {
      console.error(err);
      setError('Erreur lors du chargement des articles');
    }
  };

  useEffect(() => {
    fetchArticles(showTrash);
  }, [showTrash]);

  const deleteArticle = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`/article/${id}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error('Erreur lors de la suppression');

    // Refresh list after deletion instead of optimistic update
    await fetchArticles(showTrash);
    setMessage('Article supprimé');
  } catch (err) {
    console.error(err);
    setError('Erreur de suppression');
  }
};


  const restoreArticle = async (id) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/article/recover/${id}`, {
        method: 'PATCH',
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.status === 401) throw new Error('Non autorisé');
      if (!response.ok) throw new Error('Erreur lors de la restauration');

      const restoredArticle = await response.json();
      setArticles((prev) =>
        prev.map((a) => (a.id === id ? restoredArticle : a))
      );
      setMessage('Article restauré');
      fetchArticles(showTrash);
    } catch (err) {
      console.error(err);
      setError(err.message);
    }
  };

  const displayedArticles = useMemo(() => {
    return articles.filter((a) =>
      showTrash
        ? a.deletedAt // show deleted only
        : !a.deletedAt // show active only
    );
  }, [articles, showTrash]);

  return (
    <div className="dashboard-container">
      <div className="top-bar">
        <h3>{showTrash ? 'Articles supprimés' : 'Gestion des articles'}</h3>
        <div>
          <button
            onClick={() => navigate('/admin/articles/new')}
            className="bout-new"
          >
            <FontAwesomeIcon icon={faPlus} style={{ marginRight: '8px' }} />
            Nouvel article
          </button>
          <button
            onClick={() => setShowTrash((prev) => !prev)}
            className="bout-trash"
          >
            <FontAwesomeIcon
              icon={showTrash ? faEye : faTrash}
              style={{ marginRight: '8px' }}
            />
            {showTrash ? 'Liste des articles' : 'Corbeille'}
          </button>
        </div>
      </div>

      {message && <p style={{ color: 'green' }}>{message}</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <table className="articles-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Titre</th>
            <th>Sous-titre</th>
            <th>Date de publication</th>
            <th>Tags</th>
            <th>Image</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {displayedArticles.map((article) => (
            <tr key={article.id}>
              <td>{article.id}</td>
              <td>{article.title}</td>
              <td>{article.subtitle}</td>
              <td>{new Date(article.postingDate).toLocaleDateString()}</td>
              <td>{article.tags?.join(', ')}</td>
              <td>
                {article.imageUrl ? (
                  <img
                    src={`/${article.imageUrl}`}
                    alt={article.title}
                    width="80"
                    height="50"
                    style={{ objectFit: 'cover' }}
                  />
                ) : (
                  <span>-</span>
                )}
              </td>
              <td>
                {article.deletedAt ? (
                  <button
                    onClick={() => restoreArticle(article.id)}
                    className="icon-button text-red-600"
                    title="Restaurer"
                  >
                    <FontAwesomeIcon icon={faUndo} />
                  </button>
                ) : (
                  <>
                  <button
                       onClick={() =>
                        navigate(`/admin/articles/${article.id}`)
                      }
                      className="icon-button text-red-600"
                      title="afficher"
                    >
                      <FontAwesomeIcon icon={faEye} />
                    </button>
                    <button
                      onClick={() =>
                        navigate(`/admin/articles/edit/${article.id}`)
                      }
                      className="icon-button text-green-600"
                      title="Éditer"
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                    <button
                      onClick={() => deleteArticle(article.id)}
                      className="icon-button text-red-600"
                      title="Supprimer"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>

                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      
    </div>
  );
};

export default ListArticles;
